import React, {PropsWithChildren} from 'react';
import {View, TouchableOpacity, Platform, ViewStyle} from 'react-native';
import {responsiveWidth} from 'react-native-responsive-dimensions';

import {svg} from '../assets/svg';
import {theme} from '../constants';
import {ProductType} from '../types';
import {useAppNavigation} from '../hooks';
import ProductName from './product/ProductName';
import ProductPrice from './product/ProductPrice';
import ProductInCart from './product/ProductInCart';
import ImageBackground from './custom/ImageBackground';
import ProductInWishlist from './product/ProductInWishlist';

type Props = PropsWithChildren<{
  item: ProductType;
  index?: number;
  onPress?: () => void;
}>;

const FavoriteItem: React.FC<Props> = ({item}): JSX.Element => {
  const navigation = useAppNavigation();
  const isWeb = Platform.OS === 'web';
  const cardWidth = isWeb ? 200 : responsiveWidth(100) / 2 - 27.5;
  const imageWrapperStyle: ViewStyle = isWeb
    ? {
        width: '100%',
        height: 200,
      }
    : {
        width: '100%',
        aspectRatio: 1,
      };
  return (
    <TouchableOpacity
      style={{
        width: cardWidth,
        backgroundColor: theme.colors.backgroundPrimary,
        borderRadius: 10,
        overflow: isWeb ? 'hidden' : undefined,
      }}
      onPress={() => {
        navigation.navigate('Product', {item});
      }}
    >
      {item.image ? (
        <ImageBackground
          source={{uri: item.image}}
          style={[imageWrapperStyle, {borderRadius: 10}]}
          imageStyle={{borderRadius: 10}}
        >
          {item.isNew && (
            <View style={{padding: 14}}>
              <svg.NewSvg />
            </View>
          )}
          <ProductInWishlist
            item={item}
            containerStyle={{
              position: 'absolute',
              right: 0,
              bottom: 0,
              padding: 14,
            }}
          />
        </ImageBackground>
      ) : (
        <View
          style={{
            ...imageWrapperStyle,
            borderRadius: 10,
            backgroundColor: '#E9F3F6',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {item.isNew && (
            <View style={{position: 'absolute', top: 0, left: 0, padding: 14}}>
              <svg.NewSvg />
            </View>
          )}
          <ProductInWishlist
            item={item}
            containerStyle={{
              position: 'absolute',
              right: 0,
              bottom: 0,
              padding: 14,
            }}
          />
          <ProductName item={item} style={{color: theme.colors.textMuted}} />
        </View>
      )}
      <View
        style={{
          paddingHorizontal: 14,
          paddingBottom: 14,
          paddingTop: isWeb ? 10 : undefined,
        }}
      >
        <ProductName
          item={item}
          style={{
            marginBottom: 3,
            color: theme.colors.textMuted,
          }}
        />
        <ProductPrice
          item={item}
          gram={true}
          containerStyle={{paddingTop: isWeb ? 6 : 0}}
        />
        <ProductInCart
          item={item}
          containerStyle={{
            position: 'absolute',
            right: 0,
            bottom: 0,
            padding: 14,
          }}
        />
      </View>
    </TouchableOpacity>
  );
};

export default FavoriteItem;
